(function () {

  function subscriptionStatesInit() {

    document.addEventListener("DOMContentLoaded", function () {
      // Check if we have .shopify_subscriptions_app_block. If not, return.
      const appBlock = document.querySelector('.shopify_subscriptions_app_block');
      if (!appBlock) return;

      // Get the divs with class .shopify_subscriptions_app_block_label
      const labels = appBlock.querySelectorAll('.shopify_subscriptions_app_block_label, .shopify_subscriptions_app_block .subscription_group');

      // Function to update the active class based on the selected input
      function updateActiveClass() {
        labels.forEach(label => {
          const input = label.querySelector('input[type="radio"]');
          if (input && input.checked) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        });
      }

      // Initial update of the active class
      updateActiveClass();

      // Watch for changes on the radio inputs
      labels.forEach(label => {
        const input = label.querySelector('input[type="radio"]');
        if (input) {
          input.addEventListener('change', updateActiveClass);
        }
      });

      // Add listener to .subscription_group divs
      const subscriptionGroups = appBlock.querySelectorAll('.subscription_group');
      subscriptionGroups.forEach(group => {
        group.addEventListener('click', function (e) {
          // If the click target is an input or label inside the group, do nothing
          if (
            e.target.closest('input, label') &&
            group.contains(e.target.closest('input, label'))
          ) {
            return;
          }
          // Otherwise, check the radio input inside the group
          const radio = group.querySelector('input[type="radio"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

  }

  document.addEventListener("shopify:section:load", function (e) {
    subscriptionStatesInit();
  });

  subscriptionStatesInit();
})();
